import script from "./Features.vue?vue&type=script&setup=true&lang=ts"
export * from "./Features.vue?vue&type=script&setup=true&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=716326c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716326c4"]])

export default __exports__